import styled from 'styled-components';

export const VolumeContainer = styled.div`
  display: flex;
  padding: 24px;
  align-items: flex-start;
  gap: 24px;
`;
